module.exports = __webpack_public_path__ + "static/media/covi_phy_max_dis.88075485.png";